(() => {
  if (window.jnsModularHomeBound) return;
  window.jnsModularHomeBound = true;
  let opener;
  const page = () => document.querySelector('[data-jns-piece]');
  const container = () => window.matchMedia('(min-width: 990px)').matches
    ? document.querySelector('.page-wrapper') || document.scrollingElement
    : document.scrollingElement;
  function closeMenu() {
    const menu = document.querySelector('[data-jns-piece] .menu-toggle');
    const nav = document.querySelector('[data-jns-piece] header nav');
    nav?.classList.remove('open');
    menu?.setAttribute('aria-expanded', 'false');
    menu?.setAttribute('aria-label', 'Open menu');
  }
  function init() {
    if (!page()) return;
    document.body.classList.add('jns-editorial-page');
    document.querySelectorAll('[data-jns-piece]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      root.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        });
      });
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
        }), { threshold: .08 });
        root.querySelectorAll('.split .copy,.split .frame,.professional > h2,.pathways,.newsletter > div').forEach(el => {
          el.classList.add('reveal-ready'); observer.observe(el);
        });
      }
    });
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('a,button');
    if (!control || !control.closest('[data-jns-piece]')) return;
    if (control.matches('dialog .close')) { control.closest('dialog')?.close(); return; }
    if (control.matches('.menu-toggle')) {
      const nav = document.querySelector('[data-jns-piece] header nav');
      if (!nav) return;
      const open = nav.classList.toggle('open');
      control.setAttribute('aria-expanded', String(open));
      control.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      return;
    }
    if (control.id === 'search-open') {
      const dialog = document.querySelector('[data-jns-piece] #search');
      if (dialog && !dialog.open) { opener = control; dialog.showModal(); }
      return;
    }
    if (control.dataset.dialog) {
      const data = document.querySelector('[data-jns-content]');
      const dialog = document.querySelector('[data-jns-piece] #detail');
      if (!data || !dialog) return;
      let content;
      try { content = JSON.parse(data.textContent); } catch { return; }
      const item = content[control.dataset.dialog];
      if (!item) return;
      opener = control;
      dialog.querySelector('#detail-title').textContent = item.title;
      const body = dialog.querySelector('#detail-body');
      body.innerHTML = item.body;
      if (item.url) {
        const link = document.createElement('a'); link.className = 'pill';
        link.href = item.url; link.textContent = item.label; body.append(link);
      }
      if (!dialog.open) dialog.showModal();
      return;
    }
    if (control.matches('header nav a')) closeMenu();
    if (!control.matches('a[href^="#"]') || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const hash = control.getAttribute('href');
    if (hash.length < 2) return;
    const target = document.getElementById(hash.slice(1));
    if (!target) return;
    event.preventDefault();
    const scroller = container();
    const oldState = history.state && typeof history.state === 'object' ? history.state : {};
    history.replaceState({ ...oldState, jnsScrollTop: scroller.scrollTop }, '');
    const top = Math.max(0, scroller.scrollTop + target.getBoundingClientRect().top -
      (scroller === document.scrollingElement ? 0 : scroller.getBoundingClientRect().top));
    const url = new URL(location.href); url.hash = hash;
    if (location.hash !== hash) history.pushState({ jnsScrollTop: top, scrollTop: top }, '', url);
    scroller.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  window.addEventListener('popstate', event => {
    if (!page()) return;
    const top = event.state?.jnsScrollTop;
    if (Number.isFinite(top)) requestAnimationFrame(() => container().scrollTo({ top, behavior: 'instant' }));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.querySelector('[data-jns-piece] header nav.open')) {
      closeMenu(); document.querySelector('[data-jns-piece] .menu-toggle')?.focus();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
